/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

'use strict';

import 'vs/editor/browser/editor.all';
import 'vs/editor/contrib/quickOpen/browser/quickOutline';
import 'vs/editor/contrib/quickOpen/browser/gotoLine';
import 'vs/editor/contrib/quickOpen/browser/quickCommand';
import 'vs/editor/contrib/inspectTokens/browser/inspectTokens';

import { createMonacoBaseAPI } from 'vs/editor/common/standalone/standaloneBase';
import { createMonacoEditorAPI } from 'vs/editor/browser/standalone/standaloneEditor';
import { createMonacoLanguagesAPI } from 'vs/editor/browser/standalone/standaloneLanguages';
import { DefaultConfig } from 'vs/editor/common/config/defaultConfig';

// Set defaults for standalone editor
DefaultConfig.editor.wrappingIndent = 'none';
DefaultConfig.editor.folding = false;
DefaultConfig.editor.glyphMargin = false;

var global: any = self;
global.monaco = createMonacoBaseAPI();
global.monaco.editor = createMonacoEditorAPI();
global.monaco.languages = createMonacoLanguagesAPI();

if (typeof global.require !== 'undefined' && typeof global.require.config === 'function') {
	global.require.config({
		ignoreDuplicateModules: [
			'vscode-languageserver-types',
			'vscode-languageserver-types/main',
		]
	});
}

/** expose more stuff from monaco */
import {CommonEditorRegistry, EditorAction} from "vs/editor/common/editorCommonExtensions";
global.monaco.CommonEditorRegistry = CommonEditorRegistry;
global.monaco.EditorAction = EditorAction;
import {EditorContextKeys} from 'vs/editor/common/editorCommon';
import {KeybindingsRegistry} from 'vs/platform/keybinding/common/keybindingsRegistry';
global.monaco.EditorContextKeys = EditorContextKeys;
global.monaco.KeybindingsRegistry = KeybindingsRegistry;
import {CodeSnippet} from 'vs/editor/contrib/snippet/common/snippet';
global.monaco.CodeSnippet = CodeSnippet;
import {SnippetController} from 'vs/editor/contrib/snippet/common/snippetController';
global.monaco.SnippetController = SnippetController;
